import { Localized } from '../../i18n/I18n';
import React, { useEffect, useRef, useState } from 'react';
import { Pause, Play } from 'lucide-react';
import content from '../../data/brandContent.json';

function BrandLogo({ item, decorative = false, company = false }) {
  const [failed, setFailed] = useState(false);
  const logo = !failed && item.logo && <img src={item.logo} alt={decorative ? '' : company || item.wordmark ? item.name : item.vendor || ''} width={company ? 160 : item.wordmark ? 150 : 38} height={company ? 64 : 38} loading="lazy" onError={() => setFailed(true)}/>;
  return <Localized><li className={`bz-logo-item ${company ? 'bz-company-logo' : ''}`}>
    {company ? <span className="bz-company-logo-frame">{logo || <span>{item.name}</span>}</span> : <span className="bz-technology-logo-frame">{logo}</span>}
    {!company && <span>{item.name}</span>}
  </li></Localized>;
}

function LogoMarquee({ items }) {
  const [paused, setPaused] = useState(false);
  const [visible, setVisible] = useState(true);
  const [motion, setMotion] = useState(() => !window.matchMedia?.('(prefers-reduced-motion: reduce)').matches);
  const area = useRef(null);
  useEffect(() => {
    if (!('IntersectionObserver' in window)) return undefined;
    const observer = new IntersectionObserver(entries => setVisible(entries[0].isIntersecting));
    observer.observe(area.current);
    return () => observer.disconnect();
  }, []);
  return <Localized><div ref={area} className={`bz-logo-marquee ${motion ? 'has-motion' : 'without-motion'}`}>
    <div className={`bz-logo-window ${paused || !visible ? 'is-paused' : ''}`}><div className="bz-logo-track" style={{ '--logo-duration': `${Math.max(45, items.length * 4)}s` }}><ul aria-label="Tecnologías utilizadas">{items.map(item => <BrandLogo key={item.name} item={item}/>)}</ul>{motion && <ul aria-hidden="true">{items.map(item => <BrandLogo key={item.name} item={item} decorative/>)}</ul>}</div></div>
    <button type="button" className="bz-logo-pause" onClick={() => { if (!motion) { setMotion(true); setPaused(false); } else setPaused(value => !value); }} aria-label={!motion ? 'Activar carrusel de tecnologías' : paused ? 'Reanudar logos de tecnologías' : 'Pausar logos de tecnologías'}>{paused || !motion ? <Play size={16}/> : <Pause size={16}/>}</button>
  </div></Localized>;
}

export function Technologies() {
  return <Localized><section id="tecnologias" className="bz-technologies" aria-labelledby="bz-technologies-title"><div className="bz-shell"><div className="bz-logos-heading"><h2 id="bz-technologies-title">Tecnologías que conectamos.</h2><p>IA, cloud, sistemas empresariales y equipos.</p></div><LogoMarquee items={content.technologies}/></div></section></Localized>;
}

export function ExperienceLogos() {
  const companies = content.experience.filter(item => item.logo);
  if (!companies.length) return null;
  return <Localized><section id="experiencia" className="bz-experience-logos" aria-labelledby="bz-experience-title"><div className="bz-shell"><p id="bz-experience-title">Experiencia de nuestro equipo en</p><ul aria-label="Empresas de la trayectoria laboral del equipo">{companies.map(item => <BrandLogo key={item.name} item={item} company/>)}</ul></div></section></Localized>;
}
